import { env } from './env';

export const API_BASE_URL = env.API_ENDPOINT;

export const API_KEY = env.API_KEY;

export interface ApiError {
  status: number;
  message: string;
  detail?: string;
}

export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    'message' in error
  );
}

/**
 * Extract a user-friendly message from an RTK Query error.
 *
 * Domain errors from lumina-api arrive as:
 *   { "error-type": "LuminaApiNotFoundException", "message": "..." }
 *
 * Legacy API Gateway Lambda failures may still wrap as:
 *   { "error-type": "ServerError", "message": "<json-string>" }
 */
export function extractErrorMessage(error: unknown): string {
  const fallback = 'Something went wrong. Please try again.';
  try {
    const data = (error as Record<string, unknown>)?.data;
    if (!data || typeof data !== 'object') return fallback;

    const record = data as Record<string, unknown>;
    if (typeof record.message === 'string' && record['error-type']) {
      return record.message;
    }

    const raw = record.message;
    if (typeof raw !== 'string') return fallback;

    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === 'object' && parsed.message) {
        return parsed.message;
      }
    } catch {
      // raw is not JSON -- use it directly
    }

    return raw || fallback;
  } catch {
    return fallback;
  }
}
